module.exports = __webpack_public_path__ + "img/option-2-icon.375c096c.png";